<template>
  <div id="app">
	<router-view/>
	<cursor-comp/>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'
import CursorComp from './components/Cursor'
import 'normalize.css'
import cssVars from 'css-vars-ponyfill'

export default {
	name: 'App',
	created() {
		this.$store.dispatch('ui/updateViewportSize', {width: window.innerWidth, height: window.innerHeight})
	},
	mounted() {
		setInterval(() => {
			cssVars({
				silent: true
			})
		}, 2000)
		cssVars()
		this.addEventListeners()
		this.updateViewportSize()
	},
	beforeDestroy() {
		this.removeEventListeners()
	},
	methods: {
		addEventListeners() {
			window.addEventListener('mousemove', this.mouseMove)
			window.addEventListener('deviceorientation', this.deviceOrientation)
			window.addEventListener('resize', this.updateViewportSize)
			window.addEventListener('scroll', this.updateScrollPosition)
		},
		removeEventListeners() {
			window.removeEventListener('mousemove', this.mouseMove)
			window.removeEventListener('deviceoritentation', this.deviceOrientation)
			window.removeEventListener('resize', this.updateViewportSize)
			window.removeEventListener('scroll', this.updateScrollPosition)
		},
		updateViewportSize() {
			this.$store.dispatch('ui/updateViewportSize', {width: window.innerWidth, height: window.innerHeight})
		},
		updateScrollPosition() {
			let position = [window.scrollX || window.scollLeft || document.getElementsByTagName('html')[0].scrollLeft, window.scrollY || window.scollTop || document.getElementsByTagName('html')[0].scrollTop]
			this.$store.dispatch('ui/updateScrollPosition', {x: position[0], y: position[1]})
		},
		mouseMove(event) {
			this.$store.dispatch('ui/updateMousePosition', {x: event.clientX, y: event.clientY})
		},
		deviceOrientation(event) {
			this.$store.dispatch('ui/updateDeviceOrientation', {alpha: event.alpha, beta: event.beta, gamma: event.gamma})
		}
	},
	components: {
		CursorComp
	}
}
</script>

<style lang="scss">
body, html {
	font-size: 14px;
	font-weight: 300;
	letter-spacing: 0.133em;
	line-height: 1.4;
	@media screen and (max-width: 1600px) {
		font-size: 13px;
	}
	@media screen and (max-width: 1400px) {
		font-size: 12px;
	}
	@media screen and (max-width: 1200px) {
		font-size: 11px;
	}
	&.no-cursor, &.no-cursor * {
		cursor: none !important
	}
}
.locked {
	body {
		overflow: hidden;
		position: relative;
	}
}
:root {
	--ease: cubic-bezier(0.165, 0.84, 0.44, 1);
	--grey: #aaa;
	--spacing-horizontal: 8.28rem;
	--spacing-vertical: 6.5rem;
	--black: #222;
	--blue: #8EB8E5;
	--serif: Libre Baskerville, serif;
	--sans-serif: Source Sans pro, sans-serif;
	--title-size: 6vw;
	--left-alignment: 17%;
    --arrow-width: 6rem;
	--title-width: 10em;
	--stroke-x-1: 100;
	--stroke-x-2: 150;
	--opacity: 0.2;
	--mouse-can-move: 0;
	--color: #ccc;
	--infos-clip-x: 100;
	--infos-translate-x: 1;
	--title-x: 100;
	--subtitle-x: 100;
	--loader-frame: 100;
	--padding-x: 1.5em;
	--padding-y: 0.35em;
	--margin: 2rem;
	--image-width: 60vw;
	--image-height: calc(var(--image-width) / 1.7);
	--project-offset: calc(100vh/2 - var(--image-height) / 2);
	--clip-x: 100;
	--title-underline-scale: 0.1;
	--title-underline-origin: bottom;
	--infos-link-underline: 0;
	--progression: 100;
	--homelink-clip-x: 100;
	--icon-clip-x: 100;
	--homelink-underline-scale: 1;
	--homelink-underline-origin: bottom;
}
#app {
	display: flex;
	flex-direction: column;
	width: 100%;
	font-family: var(--sans-serif);
	@media screen and (min-aspect-ratio: 24/10) {
		--spacing-vertical: 8vh;
	}
	@media screen and (max-width: 414px) {
		--spacing-vertical: 3.27rem;
		--spacing-horizontal: 2.36rem;
	}
	* {
		box-sizing: border-box;
	}

	ul {
		padding: 0;
		margin: 0;
	}

	h1, h2, h3, h4 {
		margin: 0;
		font-weight: 500;
		line-height: 1;
        text-decoration: none;
	}

	h1 {
		font-size: 9.28rem;
	}

	h2 {
		font-size: 7vw;
		color: var(--black)
	}

	h3 {
        font-size: 1.42rem;
        font-weight: 300;
	}

	.h1 {
		@extend h1;
	}
	.h2 {
		@extend h2;
	}
	.h3 {
		@extend h3;
	}
	.h4 {
		@extend h4;
	}

	text-line {
		white-space: nowrap;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue